import { by, get } from '@services/custom.service'
import { TENNAT_API_URL } from '@services/.env'
import { BaseService } from '@services/base.service'
export default class FeatureNaming extends BaseService {
  static setFeatureRename(payload, commit) {
    return new Promise((resolve, reject) => {
      return by(`${TENNAT_API_URL}renamed_features`, payload)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          reject(this.errorWrapper(error, error.message))
        })
    })
  }
  static fetchFeatureRename(query) {
    return new Promise((resolve, reject) => {
      return get(`${TENNAT_API_URL}renamed_features`, {
        params: new URLSearchParams(query),
      })
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          reject(this.errorWrapper(error, error.message))
        })
    })
  }
}
